var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28751 20.1212L19.5343 13.1402C20.0386 12.9093 20.2635 12.3061 20.0366 11.7929C19.9361 11.5659 19.7575 11.3841 19.5343 11.2819L4.28751 4.30093C3.78317 4.07001 3.19034 4.29881 2.96338 4.81197C2.83365 5.10529 2.84767 5.44373 3.0012 5.72491L6.70833 12.2109L3.0012 18.6972C2.73261 19.1891 2.9068 19.8094 3.39026 20.0827C3.66661 20.2389 3.99922 20.2532 4.28751 20.1212Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.adc14549.svg";
export { ForwardRef as ReactComponent };